import { useSelector } from 'react-redux'
import { AppsRoutes, routerSlice, useAppsNavigate } from '@wellesley/router'
import { ROOT_ROUTE } from 'helpers/routes'

const useNavigateBack = () => {
  const navigate = useAppsNavigate()
  const previousRoute = useSelector(routerSlice.selectors.selectPreviousRoute)

  return () => navigate((previousRoute as AppsRoutes) || ROOT_ROUTE)
}

export default useNavigateBack
